module.exports = __webpack_public_path__ + "img/firstEdition3.a75ae3df.png";